import { AfterViewInit, ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  standalone: true,
  styleUrl: './adsense.component.scss',
  templateUrl: './adsense.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'd-block w-100 text-center position-relative bg-card rounded',
  },
})
export class AdsenseComponent implements AfterViewInit {
  
  public readonly adSlot: string = environment.AD_SLOT;
  public readonly adClient: string = environment.AD_CLIENT;

  public ngAfterViewInit(): void {
    setTimeout(() => {
      try {
        window['adsbygoogle' as any] = window['adsbygoogle' as any] || [];
        (window['adsbygoogle' as any] as any).push({});
      } catch (_) {
        return;
      }
    }, 500);
  }
}
